// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import registrationReducer from './registrationSlice';
import favoritesReducer from './favoritesSlice';
import filterReducer from './filterSlice';
import knowledgeBaseReducer from './knowledgeBaseSlice';
import { CountyApi } from './countySlice';
import { DocumentsApi } from './documentsSlice';
import { AccessApi } from './accessSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    registration: registrationReducer,
    favorites: favoritesReducer,
    filter: filterReducer,
    knowledgeBase: knowledgeBaseReducer,
    [CountyApi.reducerPath]: CountyApi.reducer,
    [DocumentsApi.reducerPath]: DocumentsApi.reducer,
    [AccessApi.reducerPath]: AccessApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable if dealing with non-serializable data
    }).concat(CountyApi.middleware, DocumentsApi.middleware, AccessApi.middleware),
});

export default store;
